import AppCopy from "copy/AppCopy";
import { ReportCardProps } from "declarations/card";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Paths } from "router/Paths";

function ReportCard({ report }: ReportCardProps) {
  const navigate = useNavigate();
  const { carNoText, reporterText, reportedText } = AppCopy.reportsPage;

  const handleOnPressCar = () => {
    if (!report.car?._id) return;
    navigate(`${Paths.cars}/${report.car?._id}`);
  };

  const handleOnPressReported = () => {
    if (!report.reported?._id) return;
    navigate(`${Paths.users}/${report.reported?._id}`);
  };

  const handleOnPressReporter = () => {
    if (!report.reporter?._id) return;
    navigate(`${Paths.users}/${report.reporter?._id}`);
  };

  return (
    <div className={Classname.container}>
      <div className={Classname.carNo} onClick={handleOnPressCar}>
        <span className={Classname.title}>{carNoText}</span>
        <span className={Classname.carTag}>
          {report.car?.tag}
          <span className={Classname.carTagBold}>
            {report.car?.listingType === "Rent" ? "R" : "S"}
          </span>{" "}
        </span>
      </div>
      <div className={Classname.reporter} onClick={handleOnPressReporter}>
        <span className={Classname.title}>{reporterText}</span>
        <span>{report.reporter?.name || "Unknown user"}</span>
      </div>
      <div className={Classname.reported} onClick={handleOnPressReported}>
        <span className={Classname.title}>{reportedText}</span>
        <span>{report.reported?.name || "Unknown user"}</span>
      </div>
    </div>
  );
}

export default ReportCard;

const Classname = {
  container:
    "flex w-full flex-shrink-0 flex-col justify-between border-b border-slate-100 px-2 py-3 text-sm text-secondaryText hover:bg-slate-50 sm:min-h-14 sm:flex-row sm:items-center",
  carNo: "w-full sm:w-1/4 my-1 sm:my-0 cursor-pointer",
  reporter: "w-full sm:w-1/4 text-blue cursor-pointer my-1 sm:my-0 ",
  reported: "w-full sm:w-1/4 text-blue cursor-pointer my-1 sm:my-0 ",

  title: "flex sm:hidden my-2 text-xs text-secondaryText",

  carTag:
    "flex items-center justify-center w-20 bg-bgSecondary rounded-md text-primaryText",
  carTagBold: "font-bold",

  detailsButton: "bg-primary text-white p-1 rounded-md px-3",
};
